/**
 * After a deploy, cached HTML can reference old lazy chunks → dynamic import failures.
 * One guarded reload fixes the session without adding user-facing controls.
 */
export function registerChunkLoadRecovery(): void {
  if (!import.meta.env.PROD || typeof window === 'undefined') return

  let retried = false

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      if (retried) return
      const reason = event.reason
      const msg =
        typeof reason === 'object' &&
        reason !== null &&
        'message' in reason &&
        typeof (reason as Error).message === 'string'
          ? (reason as Error).message
          : typeof reason === 'string'
            ? reason
            : ''
      const lower = msg.toLowerCase()
      const looksChunky =
        lower.includes('failed to fetch dynamically imported module') ||
        lower.includes('importing a module script failed') ||
        lower.includes('loading css chunk') ||
        lower.includes('loading chunk')
      if (!looksChunky) return
      retried = true
      window.location.reload()
    },
    { passive: true },
  )
}
